module.exports = {
	initBubbles() {

		var canvas = document.getElementById('bubbles');
		canvas.width = window.innerWidth;
		canvas.height = window.innerHeight;
		var ctx = canvas.getContext('2d');
		var bubbles = [];
		var t = 0;

		for (var i = 0; i < 5; i++) {
			bubbles[i] = blowBubble();
		}

		function resizeCanvas() {
	        canvas.width = window.innerWidth;
	        canvas.height = window.innerHeight;
        }

		function blowBubble() {
			var bubble = [];
			bubble[0] = parseInt(Math.random()*40+20); // radius
			bubble[1] = parseInt(Math.random()*canvas.width); // x
			bubble[2] = canvas.height+bubble[0]*2; // y
			bubble[3] = Math.random()*5+1; // y
			return bubble;
		}

		function moveBubbles() {
			canvas.width = canvas.width;
			for (var i = 0; i < bubbles.length; i++) {
				ctx.beginPath();
				ctx.arc(bubbles[i][1], bubbles[i][2], bubbles[i][0], 0, 2 * Math.PI, false);
				ctx.fillStyle = "rgba(255, 255, 255, 0.75)";
				ctx.fill();
				bubbles[i][2] -= bubbles[i][3];
				if (bubbles[i][2] < bubbles[i][0]*-2) {
					bubbles[i] = blowBubble();
				}
			}
			requestAnimFrame(moveBubbles);
		}

		window.requestAnimFrame =
		window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.oRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		function (moveBubbles) {
			window.setTimeout(moveBubbles, 1000 / 60);
		};

		window.addEventListener('resize', resizeCanvas, false);

		moveBubbles();
	},
	parallax() {
		var scene = document.getElementById('scene');
		var parallax = new Parallax(scene);
	}
}


// WEBPACK FOOTER //
// ./src/js/Problems-planet-ocean.js